module.exports = __webpack_public_path__ + "img/HomeTrack_Dashboard_Logo_RGB_STACKED_White.c244f6c8.svg";